import { type Dispatch, createContext } from 'react';

import { FormFieldMessagesReducerAction } from '../state/formfield-messages-state-reducer.js';
import type { FormFieldMessageContextState } from '../types/formfield-messages.types.js';

/**
 * @internal
 */
export interface FormFieldMessageContextProps {
  /** @defaultValue false */
  disabled?: boolean;
  dispatch?: Dispatch<FormFieldMessagesReducerAction>;
  state: FormFieldMessageContextState;
}

const initialState: FormFieldMessageContextState = {
  formControlMessages: [],
  customMessages: [],
  isTouched: false,
  showError: false,
  isValid: undefined,
};

/**
 * Context provider for `FormFieldMessageContextProps` to connect form controls to the applied errors and error messages.
 * @internal
 */
export const FormFieldMessageContext =
  createContext<FormFieldMessageContextProps>({
    state: initialState,
  });
